<script setup>
import TvTable from '~/components/tv/TvTable.vue';
import {tvPages, tvRowsPerPage} from '~/utils/tvDisplay';

// An americano division (current cycle)
const props = defineProps({
  panel: {type: Object, required: true},
  page: {type: Number, default: 0},
});
// wide, column or portrait (set by the panel's frame)
const mode = inject('tvMode', ref('wide'));

const division = computed(() => props.panel.americano ?? {rows: []});
const rows = computed(() => (tvPages(division.value.rows, tvRowsPerPage(props.panel, 'table', mode.value))[props.page] ?? [])
    .map(r => ({...r, diff: r.pointsDiff > 0 ? `+${r.pointsDiff}` : r.pointsDiff})));

const columns = computed(() => {
  const narrow = mode.value !== 'wide';
  return [
    {key: 'position', label: '', width: narrow ? '84px' : '110px'},
    {key: 'playerName', label: 'Player'},
    {key: 'played', label: narrow ? 'P' : 'Played', num: true, width: narrow ? '96px' : '170px'},
    {key: 'diff', label: '+/-', num: true, width: narrow ? '110px' : '150px'},
    {key: 'points', label: narrow ? 'Pts' : 'Points', num: true, strong: true, width: narrow ? '120px' : '190px'},
  ];
});
</script>

<template>
  <tv-table :columns="columns" :rows="rows" :row-key="r => r.position + r.playerName" :lead="page === 0 && division.rows.some(r => r.played > 0) ? 1 : 0"/>
</template>
